import React from 'react'
import {cn} from './cn'

interface EditorActionBarProps {
    primary: React.ReactNode
    secondary?: React.ReactNode
    destructive?: React.ReactNode
    className?: string
}

export function EditorActionBar({primary, secondary, destructive, className}: EditorActionBarProps) {
    return (
        <div className={cn(
            'flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end',
            '[&_button]:w-full [&_a]:w-full sm:[&_button]:w-auto sm:[&_a]:w-auto',
            className
        )}>
            {destructive ? (
                <div className="order-3 sm:order-1">
                    {destructive}
                </div>
            ) : null}
            {secondary ? (
                <div className="order-2 sm:order-2">
                    {secondary}
                </div>
            ) : null}
            <div className="order-1 sm:order-3">
                {primary}
            </div>
        </div>
    )
}
